module.exports = __webpack_public_path__ + "img/co-branding-orange-background.abb02f66.png";